import { render, staticRenderFns } from "./HelpContent.vue?vue&type=template&id=079c1972&scoped=true&"
import script from "./HelpContent.vue?vue&type=script&lang=js&"
export * from "./HelpContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c1972",
  null
  
)

export default component.exports